import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Container, Paper, TextField, Button, Typography, Box, Alert, Link } from '@mui/material';
import axios from 'axios';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);
    try {
      const response = await axios.post('/api/auth/forgot-password', { email });
      setMessage(response.data?.message || 'Если аккаунт существует, письмо отправлено');
    } catch (err) {
      setError(err.response?.data?.error || 'Не удалось отправить запрос');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box sx={{ marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
          <Typography component="h1" variant="h5" align="center" gutterBottom>
            Восстановление пароля
          </Typography>
          {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              margin="normal"
              required
              fullWidth
              type="email"
              label="Почта"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
            />
            <Button type="submit" fullWidth variant="contained" sx={{ mt: 2, mb: 2 }} disabled={loading}>
              Отправить ссылку
            </Button>
            <Link component={RouterLink} to="/login" variant="body2">
              Вернуться ко входу
            </Link>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}
